import { render, staticRenderFns } from "./productReportCard.vue?vue&type=template&id=0c218968&scoped=true"
import script from "./productReportCard.vue?vue&type=script&lang=js"
export * from "./productReportCard.vue?vue&type=script&lang=js"
import style0 from "./productReportCard.vue?vue&type=style&index=0&id=0c218968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c218968",
  null
  
)

export default component.exports